import { EngIcon, RusIcon, UzbIcon } from '@/_assets/icon-components';
import { TLanguageValue } from '@/_types/language';
interface ILanguage {
  id: string;
  label: string;
  icon: React.ReactNode;
  value: TLanguageValue;
}

export const languageOptions: ILanguage[] = [
  { id: '1', label: 'O’zbekcha', icon: <UzbIcon />, value: 'uz' },
  { id: '2', label: 'Русский', icon: <RusIcon />, value: 'ru' },
  { id: '3', label: 'English', icon: <EngIcon />, value: 'en' },
];

export const FEATURED_BRANDS = {
  // yaponamama: '3073b91a-c95d-4dc6-9919-92f20f21c820',
  // iramen: "7eca328a-4292-495f-b87e-96a8978be593",
  yaponamama: 'a93a4f86-b38b-404c-b1d2-7dda06aa6755',
  iramen: 'fc4ecdbc-1d69-4e0f-9ebf-7fd145497cc7',
  ris: 'e54fef8c-91d1-4356-bbb4-335df6c7df79',
  yokopizza: '178543c9-10cb-4b82-99af-868ea2bb5c8c',
}

export const BRAND_NAMES: Record<string, string> = {
  // '3073b91a-c95d-4dc6-9919-92f20f21c820': 'Yaponamama',
  // "7eca328a-4292-495f-b87e-96a8978be593": "iRamen",
  'a93a4f86-b38b-404c-b1d2-7dda06aa6755': 'Yaponamama',
  'fc4ecdbc-1d69-4e0f-9ebf-7fd145497cc7': 'iRamen',
  'e54fef8c-91d1-4356-bbb4-335df6c7df79': 'Ris',
  '178543c9-10cb-4b82-99af-868ea2bb5c8c': 'Yoko Pizza',
}

export const BRAND_SLUG: Record<string, string> = {
  // '3073b91a-c95d-4dc6-9919-92f20f21c820': "yaponamama",
  // "7eca328a-4292-495f-b87e-96a8978be593": "iramen",
  'a93a4f86-b38b-404c-b1d2-7dda06aa6755': "yaponamama",
  'fc4ecdbc-1d69-4e0f-9ebf-7fd145497cc7': "iramen",
  'e54fef8c-91d1-4356-bbb4-335df6c7df79': "ris",
  '178543c9-10cb-4b82-99af-868ea2bb5c8c': "yokopizza",
}

export const BRAND_LOGO: Record<string, string> = {
  // '3073b91a-c95d-4dc6-9919-92f20f21c820': "/images/yapona.jpeg",
  // "7eca328a-4292-495f-b87e-96a8978be593": "/images/iramen.webp",
  'a93a4f86-b38b-404c-b1d2-7dda06aa6755': "/images/yapona.jpeg",
  'fc4ecdbc-1d69-4e0f-9ebf-7fd145497cc7': "/images/iramen.webp",
  'e54fef8c-91d1-4356-bbb4-335df6c7df79': "/images/ris.webp",
  '178543c9-10cb-4b82-99af-868ea2bb5c8c': "/images/yoko.webp",
}
